
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sports/ipl/orange-cap",
      function () {
        return require("private-next-pages/sports/ipl/orange-cap/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sports/ipl/orange-cap"])
      });
    }
  